import { ApiClient } from './base/apiClient';
import type { ApiResponse } from '~/types/api/common/apiResponse';
import type { GetPersonalInformationResponse } from '~/types/api/public/getPersonalInformation';
import type { GetScreenPatternNameResponse } from '~/types/api/public/getScreenPatternName';

const BASE_PATH = '/public';

/**
 * 公開APIに関するリポジトリ
 */
export class PublicRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-807] 個人情報取扱文書取得API
   *
   * @returns 個人情報取扱文書
   */
  async getPersonalInformation(): Promise<ApiResponse<GetPersonalInformationResponse>> {
    return await this.apiClient.get<GetPersonalInformationResponse>(BASE_PATH + '/personal-information');
  }

  /**
   * [sp-api-808] 画面パターン名取得API
   *
   * @returns 画面パターン名
   */
  async getScreenPatternName(): Promise<ApiResponse<GetScreenPatternNameResponse>> {
    return await this.apiClient.get<GetScreenPatternNameResponse>(BASE_PATH + '/screen-pattern-name');
  }
}
